import { ROUTES } from "@/app/routes";

interface DefaultRouteParams {
  isPlatformAdmin: boolean;
  isInvestorOnly: boolean;
}

export function getDefaultRoute({ isPlatformAdmin, isInvestorOnly }: DefaultRouteParams): string {
  if (isPlatformAdmin) return ROUTES.PORTAL_UNAVAILABLE;
  if (isInvestorOnly) return ROUTES.PORTAL_UNAVAILABLE;
  return ROUTES.DASHBOARD;
}

interface InvitationSuccessRouteParams {
  isInvestorInvitation: boolean;
  tokenManagement: {
    isPlatformAdmin: () => boolean;
    isInvestorOnly: () => boolean;
  };
}

export function getInvitationSuccessRoute({
  isInvestorInvitation,
  tokenManagement,
}: InvitationSuccessRouteParams): string {
  return isInvestorInvitation
    ? ROUTES.PORTAL_UNAVAILABLE
    : getDefaultRoute({
        isPlatformAdmin: tokenManagement.isPlatformAdmin(),
        isInvestorOnly: tokenManagement.isInvestorOnly(),
      });
}
